import { render } from "./CallToActionSpecialOfferLayout.vue?vue&type=template&id=7753f33c&ts=true"
import script from "./CallToActionSpecialOfferLayout.vue?vue&type=script&lang=ts"
export * from "./CallToActionSpecialOfferLayout.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__